var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.446,
    height: 17.522,
    viewBox: "0 0 18.446 17.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-star",
    "data-name": "Icon material-star",
    d: "M11,15.216,15.944,18.2l-1.312-5.624L19,8.792,13.248,8.3,11,3,8.752,8.3,3,8.792l4.368,3.784L6.056,18.2Z",
    transform: "translate(-1.777 -1.719)",
    fill: "#ffce00",
    stroke: "#d1a800",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/StarFilled.11914219.svg";
export { ForwardRef as ReactComponent };